import React from 'react';
import RangeFilterPlain from './shared/RangeFilterPlain/RangeFilterPlain';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../util/urlHelpers';
import { constructQueryParamName } from '../../../util/search';

import css from './SearchPageStyles.module.css';

const SEARCH_PARAM = constructQueryParamName('clearance', 'public');

const ClearanceFilter = () => {
  const intl = useIntl();
  const history = useHistory();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <RangeFilterPlain
      className={css.draughtFilter}
      id="clearanceFilter"
      label={intl.formatMessage({ id: 'EditListingDetailsForm.clearance' })}
      queryParamNames={SEARCH_PARAM}
      initialValues={{ clearance: currentQueryParams.clearance }}
      min={0}
      max={1000}
      unit="m"
      disableMin
      showTrigger={false}
      liveEdit={true}
      compactFilter
    />
  );
};

export default ClearanceFilter;
